<template>
  <v-card>
    <v-card-text>
      <v-layout column class="pa-2">
        <v-layout row>
          <v-flex>
            <h4>{{ $t('header.organizationalData') }}</h4>
            <p>{{ $t('subTitle.organizationalData') }}</p>
          </v-flex>
          <v-spacer></v-spacer>
          <v-flex shrink>
            <v-checkbox v-model="registerSettings.metadata.organizationalData"></v-checkbox>
          </v-flex>
        </v-layout>
        <v-layout row>
          <v-flex>
            <h4>Shift System</h4>
            <p>Allows you to open and close the till on a cash drawer. Invoices will not be allowed unless the shift /
              till is open. At the end of each shift the option to count the cash in the drawer is given.
              You can set up the minimum cash the shift should be open with inside the register settings on the
              terminal.
            </p>
          </v-flex>
          <v-spacer></v-spacer>
          <v-flex shrink>
            <v-checkbox v-model="registerSettings.shiftEnabled"></v-checkbox>
          </v-flex>
        </v-layout>
        <v-layout row>
          <!-- <CloseShiftEmail
            :LocationId="LocationId"
            @updated="settingsUpdated"
          /> -->
          <v-flex v-if="isShiftEnabled">
            <v-layout row align-center>
              <v-flex>
                <b>Send Notification on closing shift</b>
                <div v-if="isEmailNotificationEnabled">
                  Currently
                  <span v-if="registerSettings.metadata">{{
                    registerSettings.metadata.closeShiftNotification.emails.length
                  }}</span>
                  <span v-else>0</span> Email(s) set.
                </div>
              </v-flex>
              <v-spacer></v-spacer>
              <v-btn v-if="registerSettings.metadata.closeShiftNotification.enabled" class="v-btn-with-radius"
                color="teal" dark @click="open()">{{ $t('buttons.edit') }}</v-btn>
              <div v-if="!registerSettings.metadata.closeShiftNotification.enabled">
                <v-btn class="v-btn-with-radius" color="info" @click="switchShiftEmail()">{{
                  $t('buttons.enable')
                }}</v-btn>
              </div>
              <div v-else>
                <v-btn class="v-btn-with-radius" color="error" @click="switchShiftEmail()">{{ $t('buttons.disable')
                  }}</v-btn>
              </div>
            </v-layout>
            <v-dialog persistent v-model="emailDialog" max-width="600px">
              <v-card class="outlined rounded-border">
                <CardToolbar :title="$t('labels.addEmail')" :isModal="true" @cancel="cancel" />
                <v-container grid-list-md>
                  <v-layout row align-center>
                    <v-flex xs12 sm4>
                      <v-text-field v-model="emailInfo.name" solo ref="emailName" :label="$t('labels.name')"
                        :error-messages="nameErrors" :hide-details="nameErrors.length === 0"></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm7>
                      <v-text-field v-model="emailInfo.email" solo :label="$t('labels.email')"
                        :error-messages="emailErrors" :hide-details="emailErrors.length === 0"></v-text-field>
                    </v-flex>
                    <v-flex shrink>
                      <v-btn class="v-btn-with-radius pt-0 mt-0 white--text" color="pink"
                        :disabled="$v.emailInfo.$invalid" @click="add()">{{ $t('buttons.add') }}</v-btn>
                    </v-flex>
                  </v-layout>
                  <v-layout row align-center v-if="emailInfoList.length > 0" xs12>
                    <v-flex>
                      <v-list>
                        <div v-for="(row, index) in emailInfoList">
                          <v-list-tile>
                            <v-list-tile-action>
                              <v-btn fab flat @click.stop.prevent="emailInfoList.splice(index, 1)">
                                <v-icon>delete</v-icon>
                              </v-btn>
                            </v-list-tile-action>
                            <v-list-tile-content>
                              <v-list-tile-title v-html="row.name"></v-list-tile-title>
                              <v-list-tile-sub-title v-html="row.email"></v-list-tile-sub-title>
                            </v-list-tile-content>
                          </v-list-tile>
                          <v-divider v-if="index + 1 < emailInfoList.length" :key="index"></v-divider>
                        </div>
                      </v-list>
                    </v-flex>
                  </v-layout>
                </v-container>
                <CardActions name="emailsUpdated" @submit="emailsUpdated" @cancel="cancel" />
              </v-card>
            </v-dialog>
          </v-flex>
        </v-layout>
        <!-- Require Inventory Feature -->
        <!-- <v-layout row>
          <v-flex>
            <h4>Require Inventory</h4>
            <p>Employees will not be able to sell serialized items unless the serial number has been purchased and entered into the stores serial list.
            </p>
          </v-flex>
          <v-spacer></v-spacer>
          <v-flex shrink>
            <v-checkbox v-model="registerSettings.requireInventory"></v-checkbox>
          </v-flex>
        </v-layout> -->
        <v-layout>
          <v-flex>
            <h4> Remove All Transactions</h4>
            <p>All Transactions and payments related to those transactions will be removed and can not be retrieved</p>
            <v-spacer></v-spacer>

            <v-btn @click="openArchiveStepperDialog('invoice')"> Remove All Transactions</v-btn>
          </v-flex>
        </v-layout>
        <v-layout>
          <v-flex>
            <h4> Remove All the Expenses</h4>
            <p>All Expenses will be removed and can not be retrieved</p>
            <v-spacer></v-spacer>
            <v-btn @click="openArchiveStepperDialog('expense')">Remove All Expenses</v-btn>
          </v-flex>
        </v-layout>
      </v-layout>
    </v-card-text>
    <v-layout justify-end row class="pa-3">
      <v-btn color="info" flat @click="cancel">{{ $t('buttons.cancel') }}</v-btn>
      <v-btn color="info" @click="update">{{ $t('buttons.update') }}</v-btn>
    </v-layout>
    <v-dialog v-model="stepperDialog" max-width="650">
      <DeleteStepper v-if="stepperDialog" :archiveModuleName="archiveModuleName" :LocationId="LocationId"
        :title="archiveModuleName == 'expense' ? 'Remove all expenses' : 'Remove all transactions'" :description="archiveModuleName == 'expense' ?
          'It will remove all the expensions' :
          'It will remove all the transactions'
          " @close="closeStepperDialog" />
    </v-dialog>
  </v-card>
</template>
<script>
import locationService from '../service.js'
const { validationMixin } = require('vuelidate')
const { required, email } = require('vuelidate/lib/validators')
import DeleteStepper from './DeleteStepper.vue'
export default {
  name: 'location-settings',
  props: ['LocationId'],
  created() {
    this.loadSettings()
  },
  data() {
    return {
      registerSettings: {
        walkInCustomer: true,
        shiftEnabled: false,
        requireInventory: false,
        stepperDialog: false,
        metadata: {
          organizationalData: false,
          closeShiftNotification: {
            enabled: null,
            emails: [],
          },
        },
      },
      archiveModuleName: null,
      stepperDialogData: null,
      stepperDialog: false,
      emailDialog: false,
      emailInfo: {
        name: null,
        email: null,
      },
      emailInfoList: [],
    }
  },
  components: {
    DeleteStepper,
  },
  computed: {
    nameErrors() {
      const errors = []
      if (!this.$v.emailInfo.name.$dirty) return errors
      if (!this.$v.emailInfo.name.required)
        errors.push(this.$t('validations.fieldIsRequired'))
      return errors
    },
    emailErrors() {
      const errors = []
      if (!this.$v.emailInfo.email.$dirty) return errors
      if (!this.$v.emailInfo.email.required)
        errors.push(this.$t('validations.fieldIsRequired'))
      if (!this.$v.emailInfo.email.email)
        errors.push(this.$t('validations.emailIsNotValid'))
      return errors
    },
    isShiftEnabled() {
      if (this.registerSettings) {
        return this.registerSettings.shiftEnabled
      }
    },
    isEmailNotificationEnabled() {
      if (this.registerSettings.metadata && this.registerSettings.metadata.closeShiftNotification) {
        return this.registerSettings.metadata.closeShiftNotification.enabledhiftNotification
      } else {
        return false
      }
    }
  },
  methods: {
    openArchiveStepperDialog(moduleName) {
      this.archiveModuleName = moduleName
      this.stepperDialog = true
    },
    openHardDeleteStepperDialog() {
      this.stepperDialog = true
    },
    closeStepperDialog() {
      this.stepperDialog = false
    },
    settingsUpdated(registerSettings) {
      this.registerSettings = {
        ...this.registerSettings,
        registerSettings
      }
    },
    async loadSettings() {
      this.$Progress.start()
      try {
        const registerSettings = (await locationService.Settings.Register.get(this.LocationId)).data
        this.registerSettings.walkInCustomer = registerSettings.walkInCustomer
        this.registerSettings.shiftEnabled = registerSettings.shiftEnabled
        this.registerSettings.requireInventory = registerSettings.requireInventory
        if (registerSettings.metadata && registerSettings.metadata.closeShiftNotification) {
          this.registerSettings.metadata = registerSettings.metadata
        } else {
          this.registerSettings.metadata = {
            ...registerSettings.metadata,
            ...this.registerSettings.metadata,
          }
        }
        this.emailInfoList = this.registerSettings.metadata.closeShiftNotification.emails
        this.$Progress.finish()
      } catch (error) {
        this.$toasted.error(error.data ? error.data.message : error.message, {
          position: 'top-right',
          showHideTransition: 'slide',
          icon: 'error',
          duration: 2000,
        })
        this.$Progress.fail()
      }
    },
    cancel() {
      this.loadSettings()
    },
    async emailsUpdated() {
      if (this.emailInfoList.length === 0) {
        this.$swal
          .mixin({
            toast: true,
            showConfirmButton: true,
            position: 'top-end',
            timer: 3000,
          })
          .fire({
            icon: 'error',
            title: 'Please add email to list.',
          })
        return false
      }
      // this.update()
      this.cancel()
    },
    reset() {
      this.emailInfo = {
        name: null,
        email: null,
      }
      this.$v.$reset()
      this.$refs.emailName.focus()
    },
    async add() {
      this.$v.$touch()

      if (this.$v.$invalid) {
        this.$swal
          .mixin({
            toast: true,
            position: 'top-end',
            timer: 3000,
          })
          .fire({
            icon: 'error',
            title: this.$t('toastMessage.text.invalidFields'),
          })
        return false
      }

      if (this.emailInfoList.some(row => row.email === this.emailInfo.email)) {
        this.$swal
          .mixin({
            toast: true,
            showConfirmButton: true,
            position: 'top-end',
            timer: 3000,
          })
          .fire({
            icon: 'error',
            title: this.$t('toastMessage.text.emailAlreadyExist'),
          })
        return false
      }

      if (this.emailInfoList.length >= 4) {
        this.checkEmail = 'can not store more then 4 emails'
      } else {
        this.emailInfoList.push(this.emailInfo)
        this.reset()
      }
    },
    async switchShiftEmail() {
      this.registerSettings.metadata.closeShiftNotification.enabled = !this.registerSettings.metadata.closeShiftNotification.enabled
    },
    open() {
      this.emailDialog = true
      this.emailInfoList = this.registerSettings.metadata.closeShiftNotification.emails
    },
    cancel() {
      this.reset()
      this.emailDialog = false
    },
    update() {
      this.$Progress.start()
      locationService.Settings.Register.update(this.LocationId, this.registerSettings)
        .then((response) => {
          this.$Progress.finish()
          this.$toasted.success('Setting was updated', {
            position: 'top-right',
            showHideTransition: 'slide',
            icon: 'check',
            duration: 2000,
          })
        })
        .catch((error) => {
          this.$Progress.fail()
          this.$toasted.error((error.data) ? error.data.message : error.message, {
            position: 'top-right',
            showHideTransition: 'slide',
            icon: 'error',
            duration: 2000,
          })
        })
    },
  },
  mixins: [validationMixin],
  validations: {
    emailInfo: {
      name: {
        required,
      },
      email: {
        required,
        email,
      },
    },
  },
}
</script>
